// @mui
// import { useTheme } from '@mui/material/styles';
// import useMediaQuery from '@mui/material/useMediaQuery';

import dayjs from "dayjs"
import {
  useReports,
  reportTypes as _reportTypes,
  reportScopes as _reportScopes
} from "./api/useReports"

export const reportTypes = _reportTypes
export const reportScopes = _reportScopes

const getDefaultDateFormat = (val) => {
  return dayjs(val).format("YYYY-MM-DD")
}

export function useReportQuery({
  reportScope,
  reportType
}) {

  const { isLoading, list, filterOperatorTypes } = useReports({ reportScope, reportType })

  const onSubmitProductItem = async ({ values, paginationModel }) => {
    // console.log('vadsfsdf', values, paginationModel)

    let {
      // locationIds,
      // createDateFrom,
      // createDateTo,
      itemName,
      itemCode,
      categoryName,
      brandName,
      uomName
    } = values

    let filterValues = [];

    // filter for location
    // locationIds.forEach(i => {
    //   filterValues.push({
    //     name: "location_id",
    //     operator: filterOperatorTypes.eq,
    //     value: i
    //   })
    // })

    // if (createDateFrom) filterValues.push({ name: "ax_createdatetime", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(createDateFrom) })
    // if (createDateTo) filterValues.push({ name: "ax_createdatetime", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(createDateTo) })
    if (itemName) filterValues.push({ name: "item_name", operator: filterOperatorTypes.contains, value: (itemName) })
    if (itemCode) filterValues.push({ name: "code", operator: filterOperatorTypes.contains, value: (itemCode) })
    if (categoryName) filterValues.push({ name: "category_name", operator: filterOperatorTypes.contains, value: (categoryName) })
    if (brandName) filterValues.push({ name: "brand_name", operator: filterOperatorTypes.contains, value: (brandName) })
    if (uomName) filterValues.push({ name: "uom_name", operator: filterOperatorTypes.contains, value: (uomName) })


    let skip = paginationModel.pageSize * paginationModel.page

    let props = {
      limit: paginationModel.pageSize,
      skip,
      sortInfo: {
        id: "code",
        dir: -1,
      },
      filterValue: filterValues
    }

    let response = await list(props);

    return response

  }

  const onSubmitSalesOrder = async ({ values, paginationModel }) => {
    // console.log('vadsfsdf', values, paginationModel)

    let {
      locationIds,
      dateFrom,
      dateTo,
      createDateFrom,
      createDateTo,
      documentNo,
      profileName,
      billingProfileName,
      deliveryProfileName
    } = values

    let filterValues = [];

    // filter for location
    // locationIds.forEach(i => {
    //   filterValues.push({
    //     name: "location_id",
    //     operator: filterOperatorTypes.eq,
    //     value: i
    //   })
    // })

    if(locationIds.length > 0){
      filterValues.push({
        name: "location_id",
        operator: filterOperatorTypes.anyOf,
        value: `${JSON.stringify(locationIds)}`
      })
    }

    if (dateFrom) filterValues.push({ name: "doc_date", operator: filterOperatorTypes.moreThanEq, value: getDefaultDateFormat(dateFrom) })
    if (dateTo) filterValues.push({ name: "doc_date", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(dateTo) })
    if (createDateFrom) filterValues.push({ name: "ax_createdatetime", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(createDateFrom) })
    if (createDateTo) filterValues.push({ name: "ax_createdatetime", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(createDateTo) })
    if (documentNo) filterValues.push({ name: "doc_number", operator: filterOperatorTypes.contains, value: (documentNo) })
    if (profileName) filterValues.push({ name: "profile_name", operator: filterOperatorTypes.contains, value: (profileName) })
    if (billingProfileName) filterValues.push({ name: "billing_profile_name", operator: filterOperatorTypes.contains, value: (billingProfileName) })
    if (deliveryProfileName) filterValues.push({ name: "delivery_profile_name", operator: filterOperatorTypes.contains, value: (deliveryProfileName) })

    let skip = paginationModel.pageSize * paginationModel.page

    let props = {
      limit: paginationModel.pageSize,
      skip,
      sortInfo: {
        id: "doc_number",
        dir: -1,
      },
      filterValue: filterValues
    }

    let response = await list(props);

    return response

  }

  const onSubmitSalesOrderItem = async ({ values, paginationModel }) => {

    let {
      locationIds,
      dateFrom,
      dateTo,
      createDateFrom,
      createDateTo,
      documentNo,
      itemName,
      itemCode,
    } = values

    let filterValues = [];

    // filter for location
    if(locationIds.length > 0){
      filterValues.push({
        name: "location_id",
        operator: filterOperatorTypes.anyOf,
        value: `${JSON.stringify(locationIds)}`
      })
    }

    if (dateFrom) filterValues.push({ name: "doc_date", operator: filterOperatorTypes.moreThanEq, value: getDefaultDateFormat(dateFrom) })
    if (dateTo) filterValues.push({ name: "doc_date", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(dateTo) })
    if (createDateFrom) filterValues.push({ name: "ax_createdatetime", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(createDateFrom) })
    if (createDateTo) filterValues.push({ name: "ax_createdatetime", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(createDateTo) })
    if (documentNo) filterValues.push({ name: "doc_number", operator: filterOperatorTypes.contains, value: (documentNo) })
    if (itemName) filterValues.push({ name: "item_name", operator: filterOperatorTypes.contains, value: (itemName) })
    if (itemCode) filterValues.push({ name: "code", operator: filterOperatorTypes.contains, value: (itemCode) })

    let skip = paginationModel.pageSize * paginationModel.page

    let props = {
      limit: paginationModel.pageSize,
      skip,
      sortInfo: {
        id: "doc_number",
        dir: -1,
      },
      filterValue: filterValues
    }

    let response = await list(props);

    return response

  }

  const onSubmitDeliveryOrder = async ({ values, paginationModel }) => {

    let {
      locationIds,
      dateFrom,
      dateTo,
      createDateFrom,
      createDateTo,
      documentNo,
      profileName,
      billingProfileName,
      deliveryProfileName
    } = values

    let filterValues = [];

    // filter for location
    if(locationIds.length > 0){
      filterValues.push({
        name: "location_id",
        operator: filterOperatorTypes.anyOf,
        value: `${JSON.stringify(locationIds)}`
      })
    }

    if (dateFrom) filterValues.push({ name: "doc_date", operator: filterOperatorTypes.moreThanEq, value: getDefaultDateFormat(dateFrom) })
    if (dateTo) filterValues.push({ name: "doc_date", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(dateTo) })
    if (createDateFrom) filterValues.push({ name: "ax_createdatetime", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(createDateFrom) })
    if (createDateTo) filterValues.push({ name: "ax_createdatetime", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(createDateTo) })
    if (documentNo) filterValues.push({ name: "doc_number", operator: filterOperatorTypes.contains, value: (documentNo) })
    if (profileName) filterValues.push({ name: "profile_name", operator: filterOperatorTypes.contains, value: (profileName) })
    if (billingProfileName) filterValues.push({ name: "billing_profile_name", operator: filterOperatorTypes.contains, value: (billingProfileName) })
    if (deliveryProfileName) filterValues.push({ name: "delivery_profile_name", operator: filterOperatorTypes.contains, value: (deliveryProfileName) })

    let skip = paginationModel.pageSize * paginationModel.page

    let props = {
      limit: paginationModel.pageSize,
      skip,
      sortInfo: {
        id: "doc_number",
        dir: -1,
      },
      filterValue: filterValues
    }

    let response = await list(props);

    return response

  }

  const onSubmitDeliveryOrderItem = async ({ values, paginationModel }) => {

    let {
      locationIds,
      dateFrom,
      dateTo,
      createDateFrom,
      createDateTo,
      documentNo,
      itemName,
      itemCode,
    } = values

    let filterValues = [];

    // filter for location
    if(locationIds.length > 0){
      filterValues.push({
        name: "location_id",
        operator: filterOperatorTypes.anyOf,
        value: `${JSON.stringify(locationIds)}`
      })
    }

    if (dateFrom) filterValues.push({ name: "doc_date", operator: filterOperatorTypes.moreThanEq, value: getDefaultDateFormat(dateFrom) })
    if (dateTo) filterValues.push({ name: "doc_date", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(dateTo) })
    if (createDateFrom) filterValues.push({ name: "ax_createdatetime", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(createDateFrom) })
    if (createDateTo) filterValues.push({ name: "ax_createdatetime", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(createDateTo) })
    if (documentNo) filterValues.push({ name: "doc_number", operator: filterOperatorTypes.contains, value: (documentNo) })
    if (itemName) filterValues.push({ name: "item_name", operator: filterOperatorTypes.contains, value: (itemName) })
    if (itemCode) filterValues.push({ name: "code", operator: filterOperatorTypes.contains, value: (itemCode) })

    let skip = paginationModel.pageSize * paginationModel.page

    let props = {
      limit: paginationModel.pageSize,
      skip,
      sortInfo: {
        id: "doc_number",
        dir: -1,
      },
      filterValue: filterValues
    }

    let response = await list(props);

    return response

  }

  const onSubmitItemReceive = async ({ values, paginationModel }) => {
    // console.log('vadsfsdf', values, paginationModel)

    let {
      locationIds,
      dateFrom,
      dateTo,
      createDateFrom,
      createDateTo,
      documentNo,
      profileName,
    } = values

    let filterValues = [];

    // filter for location
    if(locationIds.length > 0){
      filterValues.push({
        name: "location_id",
        operator: filterOperatorTypes.anyOf,
        value: `${JSON.stringify(locationIds)}`
      })
    }

    if (dateFrom) filterValues.push({ name: "doc_date", operator: filterOperatorTypes.moreThanEq, value: getDefaultDateFormat(dateFrom) })
    if (dateTo) filterValues.push({ name: "doc_date", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(dateTo) })
    if (createDateFrom) filterValues.push({ name: "ax_createdatetime", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(createDateFrom) })
    if (createDateTo) filterValues.push({ name: "ax_createdatetime", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(createDateTo) })
    if (documentNo) filterValues.push({ name: "doc_number", operator: filterOperatorTypes.contains, value: (documentNo) })
    if (profileName) filterValues.push({ name: "profile_name", operator: filterOperatorTypes.contains, value: (profileName) })

    let skip = paginationModel.pageSize * paginationModel.page

    let props = {
      limit: paginationModel.pageSize,
      skip,
      sortInfo: {
        id: "doc_number",
        dir: -1,
      },
      filterValue: filterValues
    }

    let response = await list(props);

    return response

  }

  const onSubmitItemReceiveItem = async ({ values, paginationModel }) => {

    let {
      locationIds,
      dateFrom,
      dateTo,
      createDateFrom,
      createDateTo,
      documentNo,
      profileName,
      itemName,
      itemCode
    } = values

    let filterValues = [];

    // filter for location
    if(locationIds.length > 0){
      filterValues.push({
        name: "location_id",
        operator: filterOperatorTypes.anyOf,
        value: `${JSON.stringify(locationIds)}`
      })
    }

    if (dateFrom) filterValues.push({ name: "doc_date", operator: filterOperatorTypes.moreThanEq, value: getDefaultDateFormat(dateFrom) })
    if (dateTo) filterValues.push({ name: "doc_date", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(dateTo) })
    if (createDateFrom) filterValues.push({ name: "ax_createdatetime", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(createDateFrom) })
    if (createDateTo) filterValues.push({ name: "ax_createdatetime", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(createDateTo) })
    if (documentNo) filterValues.push({ name: "doc_number", operator: filterOperatorTypes.contains, value: (documentNo) })
    if (profileName) filterValues.push({ name: "profile_name", operator: filterOperatorTypes.contains, value: (profileName) })
    if (itemName) filterValues.push({ name: "item_name", operator: filterOperatorTypes.contains, value: (itemName) })
    if (itemCode) filterValues.push({ name: "code", operator: filterOperatorTypes.contains, value: (itemCode) })

    let skip = paginationModel.pageSize * paginationModel.page

    let props = {
      limit: paginationModel.pageSize,
      skip,
      sortInfo: {
        id: "doc_number",
        dir: -1,
      },
      filterValue: filterValues
    }

    let response = await list(props);

    return response

  }

  const onSubmitItemTransfer = async ({ values, paginationModel }) => {

    let {
      locationIds,
      toLocationIds,
      dateFrom,
      dateTo,
      createDateFrom,
      createDateTo,
      documentNo,
      profileName,
      // billingProfileName,
      // deliveryProfileName
    } = values

    let filterValues = [];

    // filter for location
    if(locationIds.length > 0){
      filterValues.push({
        name: "location_id",
        operator: filterOperatorTypes.anyOf,
        value: `${JSON.stringify(locationIds)}`
      })
    }


    if(typeof toLocationIds !== "undefined"  && toLocationIds.length > 0){
      filterValues.push({
        name: "to_location_id",
        operator: filterOperatorTypes.anyOf,
        value: `${JSON.stringify(toLocationIds)}`
      })
    }

    if (dateFrom) filterValues.push({ name: "doc_date", operator: filterOperatorTypes.moreThanEq, value: getDefaultDateFormat(dateFrom) })
    if (dateTo) filterValues.push({ name: "doc_date", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(dateTo) })
    if (createDateFrom) filterValues.push({ name: "ax_createdatetime", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(createDateFrom) })
    if (createDateTo) filterValues.push({ name: "ax_createdatetime", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(createDateTo) })
    if (documentNo) filterValues.push({ name: "doc_number", operator: filterOperatorTypes.contains, value: (documentNo) })
    if (profileName) filterValues.push({ name: "profile_name", operator: filterOperatorTypes.contains, value: (profileName) })
    // if (billingProfileName) filterValues.push({ name: "billing_profile_name", operator: filterOperatorTypes.eq, value: (billingProfileName) })
    // if (deliveryProfileName) filterValues.push({ name: "delivery_profile_name", operator: filterOperatorTypes.eq, value: (deliveryProfileName) })

    let skip = paginationModel.pageSize * paginationModel.page

    let props = {
      limit: paginationModel.pageSize,
      skip,
      sortInfo: {
        id: "doc_number",
        dir: -1,
      },
      filterValue: filterValues
    }

    let response = await list(props);

    return response

  }

  const onSubmitItemTransferItem = async ({ values, paginationModel }) => {

    let {
      locationIds,
      toLocationIds,
      dateFrom,
      dateTo,
      createDateFrom,
      createDateTo,
      documentNo,
      profileName,
      itemName,
      itemCode
    } = values

    let filterValues = [];

    // filter for location
    if(locationIds.length > 0){
      filterValues.push({
        name: "location_id",
        operator: filterOperatorTypes.anyOf,
        value: `${JSON.stringify(locationIds)}`
      })
    }

    if(typeof toLocationIds !== "undefined"  && toLocationIds.length > 0){
      filterValues.push({
        name: "to_location_id",
        operator: filterOperatorTypes.anyOf,
        value: `${JSON.stringify(toLocationIds)}`
      })
    }

    if (dateFrom) filterValues.push({ name: "doc_date", operator: filterOperatorTypes.moreThanEq, value: getDefaultDateFormat(dateFrom) })
    if (dateTo) filterValues.push({ name: "doc_date", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(dateTo) })
    if (createDateFrom) filterValues.push({ name: "ax_createdatetime", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(createDateFrom) })
    if (createDateTo) filterValues.push({ name: "ax_createdatetime", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(createDateTo) })
    if (documentNo) filterValues.push({ name: "doc_number", operator: filterOperatorTypes.contains, value: (documentNo) })
    if (profileName) filterValues.push({ name: "profile_name", operator: filterOperatorTypes.contains, value: (profileName) })
    if (itemName) filterValues.push({ name: "item_name", operator: filterOperatorTypes.contains, value: (itemName) })
    if (itemCode) filterValues.push({ name: "code", operator: filterOperatorTypes.contains, value: (itemCode) })

    let skip = paginationModel.pageSize * paginationModel.page

    let props = {
      limit: paginationModel.pageSize,
      skip,
      sortInfo: {
        id: "doc_number",
        dir: -1,
      },
      filterValue: filterValues
    }

    let response = await list(props);

    return response

  }

  const onSubmitStockValue = async ({ values, paginationModel }) => {

    let {
      locationIds,
      // createDateFrom,
      // createDateTo,
      itemName,
      itemCode,
      categoryName,
      brandName,
      uomName,
    } = values

    let filterValues = [];

    // filter for location
    // locationIds.forEach(i => {
      if(locationIds.length > 0){
        filterValues.push({
          name: "location_id",
          operator: filterOperatorTypes.anyOf,
          value: `${JSON.stringify(locationIds)}`
        })
      }
    // })

    // if (createDateFrom) filterValues.push({ name: "ax_createdatetime", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(createDateFrom) })
    // if (createDateTo) filterValues.push({ name: "ax_createdatetime", operator: filterOperatorTypes.lessThanEq, value: getDefaultDateFormat(createDateTo) })
    if (itemName) filterValues.push({ name: "item_name", operator: filterOperatorTypes.contains, value: (itemName) })
    if (itemCode) filterValues.push({ name: "code", operator: filterOperatorTypes.contains, value: (itemCode) })
    if (categoryName) filterValues.push({ name: "category_name", operator: filterOperatorTypes.contains, value: (categoryName) })
    if (brandName) filterValues.push({ name: "brand_name", operator: filterOperatorTypes.contains, value: (brandName) })
    if (uomName) filterValues.push({ name: "uom_name", operator: filterOperatorTypes.contains, value: (uomName) })

    let skip = paginationModel.pageSize * paginationModel.page

    let props = {
      limit: paginationModel.pageSize,
      offset: -1,
      skip,
      sortInfo: {
        id: "code",
        dir: -1,
      },
      filterValue: filterValues,
      dataTypes: ["stock_value", "group_location"]
    }

    let response = await list(props);

    return response

  }

  let onSubmit = () => { }

  // if (reportScope === reportScopes.sales) {
  if (reportType === reportTypes.product.productItem.id) {
    onSubmit = onSubmitProductItem
  }if (reportType === reportTypes.sales.salesOrder.id) {
    onSubmit = onSubmitSalesOrder
  }
  if (reportType === reportTypes.sales.salesOrderItem.id) {
    onSubmit = onSubmitSalesOrderItem
  }
  if (reportType === reportTypes.sales.deliveryOrder.id) {
    onSubmit = onSubmitDeliveryOrder
  }
  if (reportType === reportTypes.sales.deliveryOrderItem.id) {
    onSubmit = onSubmitDeliveryOrderItem
  }
  if (reportType === reportTypes.warehouse.itemReceive.id) {
    onSubmit = onSubmitItemReceive
  }
  if (reportType === reportTypes.warehouse.itemReceiveItem.id) {
    onSubmit = onSubmitItemReceiveItem
  }
  if (reportType === reportTypes.warehouse.itemTransfer.id) {
    onSubmit = onSubmitItemTransfer
  }
  if (reportType === reportTypes.warehouse.itemTransferItem.id) {
    onSubmit = onSubmitItemTransferItem
  }
  if (reportType === reportTypes.inventory.stockValue.id) {
    onSubmit = onSubmitStockValue
  }
  // }

  return {
    isLoading,
    onSubmit
  }

}
